
import { Component } from 'nuxt-property-decorator'
import { Convegno } from '~/types/models/Convegno'
import SeoMetaComponent from '@/components/classes/meta'

@Component
export default class ConvegnoPage extends SeoMetaComponent {
  public item: Convegno | null = null

  async fetch() {
    try {
      const { data } = await this.$axios.get(
        'convegni/' + this.$route.params.slug
      )
      this.item = data as Convegno
      this.loadMeta({
        titolo: data.titolo,
        contenuto: data.abstract,
        image: this.getImage(),
        slug: 'convegni/' + this.$route.params.slug,
      })
    } catch (error: any) {
      if (error?.response?.status === 404) {
        this.$nuxt.error({
          statusCode: error?.response?.status,
          message: 'Convegno non trovato',
        })
      } else {
        this.$nuxt.error({
          statusCode: 500,
        })
      }

      throw error
    }
  }

  fetchOnServer() {
    return true
  }

  public getImage() {
    if (!this.item?.mainImage) {
      return '/img/blog-11.jpg'
    }
    const image = this.item?.mainImage
    return this.$config.cdnEndpoint + '1024/' + image.originalName
  }

  public getFile() {
    if (!this.item?.allegato) {
      return '#'
    }
    const document = this.item?.allegato
    return this.$config.cdnEndpointDocuments + document.name
  }

  public getDomainName(item: Convegno) {
    const url = new URL(item?.website)
    return url?.hostname?.replace('www.', '')
  }

  public getCurrentLink(): string {
    if (process.client) {
      return window.location.href
    }
    return '#'
  }
}
